<main>
  <loading-overlay [isLoading]="isLoading > 0" />
  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'UserDetails_Title' | translateWF: 'Users Details' }}</h1>
      </div>
    </div>

    <div class="grid-12">
      <div class="span-12">
        <p-panel>
          <p-card data-variant="compact">
            <p-tabs [value]="isDelegate() ? '1' : '0'">
              <p-tablist>
                @if (!isDelegate()) {
                  <p-tab value="0">
                    {{ 'UserDetails_Tab_Roles' | translateWF: 'Roles' }}
                  </p-tab>
                }
                <p-tab value="1">
                  {{ 'UserDetails_Tab_Groups' | translateWF: 'Groups' }}
                </p-tab>
              </p-tablist>
              <p-tabpanels>
                <!-- ROLES -->
                @if (!isDelegate()) {
                  <p-tabpanel value="0">
                    <p-panel>
                      <ng-template pTemplate="icons">
                        <div class="row-sm-start-center">
                          <p-iconfield>
                            <p-inputicon styleClass="pi pi-search" />
                            <input type="text" pInputText placeholder="{{ 'UserDetails_Search_Roles' | translateWF: 'Search Roles' }}" (input)="sortData($event, 'roles')" />
                          </p-iconfield>
                          <p-button variant="outlined" label="{{ 'UserDetails_Add' | translateWF: 'Add' }}" icon="pi pi-plus" (onClick)="openModalRoles(null)" />
                        </div>
                      </ng-template>

                      <p-card data-variant="compact">
                        <p-table [value]="listSortRoles()!" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[5, 10, 20]" selectionMode="single">
                          <ng-template #header>
                            <tr>
                              <th>
                                {{ 'UserDetails_Table_Role' | translateWF: 'Role' }}
                              </th>
                              <th>{{ 'UserDetails_Table_Type' | translateWF: 'Type' }}</th>
                              <th></th>
                            </tr>
                          </ng-template>
                          <ng-template #body let-role>
                            <tr class="cursor-pointer">
                              <td>{{ role.name }}</td>
                              <td>{{ typeLabel(role.type).key | translateWF: typeLabel(role.type).fallback }}</td>
                              <td class="!text-end">
                                <p-button variant="outlined" icon="pi pi-pencil" (onClick)="openModalRoles(role)" />
                              </td>
                            </tr>
                          </ng-template>
                        </p-table>
                      </p-card>
                    </p-panel>
                  </p-tabpanel>
                }

                <!-- GROUPS -->
                <p-tabpanel value="1">
                  <p-panel>
                    <ng-template pTemplate="icons">
                      <div class="row-sm-start-center">
                        <p-iconfield>
                          <p-inputicon styleClass="pi pi-search" />
                          <input type="text" pInputText placeholder="{{ 'UserDetails_Search_Groups' | translateWF: 'Search Groups' }}" (input)="sortData($event, 'groups')" />
                        </p-iconfield>
                        @if (!isDelegate()) {
                          <p-button variant="outlined" label="{{ 'UserDetails_Add' | translateWF: 'Add' }}" icon="pi pi-plus" (onClick)="openModalGroups(null)" />
                        }
                      </div>
                    </ng-template>
                    <p-card data-variant="compact">
                      <p-table [value]="listSortGroups()!" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[5, 10, 20]" selectionMode="single">
                        <ng-template #header>
                          <tr>
                            <th>
                              {{ 'UserDetails_Table_Group' | translateWF: 'Group' }}
                            </th>
                            <th>{{ 'UserDetails_Table_Type' | translateWF: 'Type' }}</th>
                            <th>{{ 'UserDetails_Table_ExternalManagers' | translateWF: 'External managers' }}</th>
                            <th></th>
                          </tr>
                        </ng-template>
                        <ng-template #body let-group>
                          <tr class="cursor-pointer">
                            <td>{{ group.name }}</td>
                            <td>{{ typeLabel(group.type).key | translateWF: typeLabel(group.type).fallback }}</td>
                            <td>
                              @if (isGlobal(group)) {
                                {{ 'UserDetails_ExternalManagers_NotAllowed' | translateWF: 'Not allowed (Global)' }}
                              } @else if (group.isDelegable) {
                                <p-tag severity="success" [value]="'UserDetails_ExternalManagers_Visible' | translateWF: 'Visible'" />
                              } @else {
                                {{ 'UserDetails_ExternalManagers_Hidden' | translateWF: 'Hidden' }}
                              }
                            </td>
                            <td class="!text-end">
                              @if (!isDelegate()) {
                                <p-button variant="outlined" icon="pi pi-pencil" (onClick)="openModalGroups(group)" />
                              }
                            </td>
                          </tr>
                        </ng-template>
                      </p-table>
                    </p-card>
                  </p-panel>
                </p-tabpanel>
              </p-tabpanels>
            </p-tabs>
          </p-card>
        </p-panel>
      </div>
    </div>
  </div>
</main>
